export default __webpack_public_path__ + "static/media/00.153e2a80.jpg";